import { render } from "./PromotionDetail.vue?vue&type=template&id=323e2e21&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"

import "./PromotionDetail.vue?vue&type=style&index=0&id=323e2e21&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e2e21"]])

export default __exports__